import React from 'react';

import ErrorPageTemplate from 'ibis-design-system/lib/components/errorPages/ErrorPageTemplate'
import TemplateErrorForm from 'ibis-design-system/lib/components/errorPages/TemplateErrorForm'

const GraphError = (props) => {

    return <ErrorPageTemplate>
        <ErrorPageTemplate.Title>Error during logon</ErrorPageTemplate.Title>
        <ErrorPageTemplate.Content>
            Microsoft Azure Activity Directory did authenticate your account, but we were unable to retrieve your account information.
            Please try again or if the problem is consistent contact IBIS support.
        </ErrorPageTemplate.Content>
        <ErrorPageTemplate.Form>
            <TemplateErrorForm />
        </ErrorPageTemplate.Form>
    </ErrorPageTemplate>
}

export default GraphError;